import { defineComponent, h, onMounted, ref, resolveComponent } from 'vue'
import { RouterLink, useRoute } from 'vue-router'

import {
  CBadge,
  CSidebarNav,
  CSidebarToggler,
  CNavItem,
  CNavGroup,
  CNavTitle,
} from '@coreui/vue-pro'
import navSuperAdmin from '@/router/SuperAdministrator/navi.js'
import navAdmin from '@/router/Administrator/navi.js'
import navFacility from '@/router/Facility/navi.js'
import navAppUser from '@/router/AppUser/navi.js'
import AuthService from '@/_services/auth.service'

let payload
let user = JSON.parse(localStorage.getItem('user'))
if (user) {
  payload = AuthService.getPayload()
}

const normalizePath = (path) =>
  decodeURI(path)
    .replace(/#.*$/, '')
    .replace(/(index)?\.(html)$/, '')

const isActiveLink = (route, link) => {
  if (link === undefined) {
    return false
  }

  if (route.hash === link) {
    return true
  }

  const currentPath = normalizePath(route.path)
  const targetPath = normalizePath(link)

  return currentPath === targetPath
}

const isActiveItem = (route, item) => {
  if (isActiveLink(route, item.to)) {
    return true
  }

  if (item.items) {
    return item.items.some((child) => isActiveItem(route, child))
  }

  return false
}

const AppSidebarNav = defineComponent({
  name: 'AppSidebarNav',
  components: {
    CNavItem,
    CNavGroup,
    CNavTitle,
    CSidebarToggler,
  },
  setup() {
    const route = useRoute()
    const firstRender = ref(true)
    let customNav = ''

    if (payload) {
      if (payload.roleId == '1') {
        customNav = navSuperAdmin
      } else if (payload.roleId == '2') {
        customNav = navAdmin
      } else if (payload.roleId == '3') {
        customNav = navFacility
      } else if (payload.roleId == '4') {
        customNav = navAppUser
      }
    }

    onMounted(() => {
      firstRender.value = false
    })

    const renderItem = (item) => {
      if (item.items) {
        return h(
          CNavGroup,
          {
            ...(firstRender.value && {
              visible: item.items.some((child) => isActiveItem(route, child)),
            }),
          },
          {
            togglerContent: () => [
              h(resolveComponent('CIcon'), {
                customClassName: 'nav-icon',
                name: item.icon,
              }),
              item.name,
            ],
            default: () => item.items.map((child) => renderItem(child)),
          },
        )
      }

      return item.to
        ? h(
            RouterLink,
            {
              to: item.to,
              custom: true,
            },
            {
              default: (props) =>
                h(
                  resolveComponent(item.component),
                  {
                    active: props.isActive,
                    href: props.href,
                    onClick: () => props.navigate(),
                  },
                  {
                    default: () => [
                      item.icon &&
                        h(resolveComponent('CIcon'), {
                          customClassName: 'nav-icon',
                          name: item.icon,
                        }),
                      item.name,
                      item.badge &&
                        h(
                          CBadge,
                          {
                            class: 'ms-auto',
                            color: item.badge.color,
                          },
                          {
                            default: () => item.badge.text,
                          },
                        ),
                    ],
                  },
                ),
            },
          )
        : h(
            resolveComponent(item.component),
            {},
            {
              default: () => item.name,
            },
          )
    }

    return () =>
      h(
        CSidebarNav,
        {},
        {
          default: () => customNav.map((item) => renderItem(item)),
        },
      )
  },
})
export { AppSidebarNav }
